<template>
  <div class="columns">
    <div class="column is-7">
      <h3 class="title is-6">{{ $t('docflow.checkouts_list') }}</h3>
      <b-autocomplete
          class="user-search"
          type="text"
          icon="magnify"
          v-model="searchQuery"
          :data="correspondents"
          :placeholder="$t('docflow.inputNameToAdd')"
          field="title"
          :loading="loading"
          @input="search"
          @select="add"
          v-if="editable">
        <template slot-scope="props">
          <div class="media-content">
            <template v-if="props.option.type === 'new'">
              {{ $t('docflow.addNewCorespondent', {name: props.option.name}) }}
            </template>
            <template v-else>{{ props.option.name }}</template>
          </div>
        </template>
      </b-autocomplete>
      <b-table :data="detail.checkouts" class="maintainers-table">
        <template slot-scope="props">
          <b-table-column :label="$t('docflow.checkout.name')" field="name" sortable>
            {{ props.row.employee__initials }}
          </b-table-column>
          <b-table-column :label="$t('docflow.checkout.state')" width="240">
            {{ $t(`docflow.checkout.states.${props.row.state}`) }}
          </b-table-column>
          <b-table-column :label="$t('tasks.actions')" width="120" v-if="editable">
            <a @click.prevent="remove(props.row.id)">
              <b-icon icon="trash-can-outline" size="is-small"></b-icon> {{ $t('interface.remove') }}
            </a>
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content is-fluid has-text-grey has-text-centered">
              <p>
                <span class="has-text-grey-light">{{ $t('docflow.correspondentsAddTip') }}</span>
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
    <div class="column is-5">
      <h3 class="title is-6">{{ $t('docflow.progress') }}</h3>
      <Timeline class="mt-15"
                :data="timeline">
      </Timeline>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import Timeline from '@/components/Timeline'
  import {timelineItem} from '@/constants'
  import {debounce} from '@/utils'

  export default {
    components: {
      Timeline
    },
    data() {
      return {
        searchQuery: null
      }
    },
    methods: {
      search: debounce(function() {
        this.$store.dispatch('Reference/getCorrespondents', {searchQuery: this.searchQuery, scope: 'employees'})
      }),
      remove(checkoutId) {
        this.$store.dispatch('Docflow/removeCheckouts', checkoutId).then(() => this.$emit('refresh'));
      },
      add(employee) {
        this.$store.dispatch('Docflow/createCheckouts', employee.id).then(() => this.$emit('refresh'));
      }
    },
    computed: {
      ...mapState('Docflow', ['detail', 'upload']),
      ...mapState('Account', ['account']),
      ...mapGetters('Account', ['isDocflowManager', 'isDocflowApprover']),
      ...mapState('Reference', ['loading', 'correspondents']),
      isMaintainer() {
        return this.detail.maintainer ? this.detail.maintainer.id === this.account.employee.id : false
      },
      editable() {
        return (this.isMaintainer || this.detail.author.id === this.account.employee.id) && this.detail.state === 'new'
      },
      timeline() {
        return this.detail.checkout_states ? this.detail.checkout_states.map(state => {
          return {
            ...timelineItem,
            date: state.created_at,
            title: this.$t(`docflow.checkout.states.${state.state}`),
            note: `${state.employee__initials}${state.note ? ` – ${state.note}` : ''}`,
          }
        }) : []
      }
    }
  }
</script>

<style scoped>

</style>
